import React, {Component} from 'react';
import {isExternalLink} from '../utilities/links';
import IconAgent from './IconAgent';

export default class VendorItem extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    iconName: '',
    iconClassName: 'icon',
    isXoVendor: false,
    xoVendorLink: '/',
    xoVendorLinkData: '',
    vendorName: '',
    iconTrackingData: '',
  };

  vendorTrackEvents = () => {
    const {xoVendorLinkData} = this.props;
    let detailEvent;

    if (xoVendorLinkData['source-type'] == 'photo') {
      detailEvent = {
        photoId: xoVendorLinkData['photo-id'],
        photoTag: xoVendorLinkData['photo-tag'],
      };
    } else {
      detailEvent = {
        albumId: xoVendorLinkData['album-id'],
        albumTag: xoVendorLinkData['album-tag'],
      };
    }

    let defalutEvent = {
      platform: xoVendorLinkData.platform,
      product: xoVendorLinkData.product,
      sourceType: xoVendorLinkData['source-type'],
      trackingEvent: xoVendorLinkData['tracking-event'],
      vendorId: xoVendorLinkData['vendor-id'],
      vendorName: xoVendorLinkData['vendor-name'],
      spinnable: xoVendorLinkData.spinnable,
    };

    let vendorEvent = Object.assign(defalutEvent, detailEvent);
    analytics.track(xoVendorLinkData['tracking-event'], vendorEvent);
  };

  vendorLink = () => {
    const {
      xoVendorLink,
      vendorName,
      xoVendorLinkData,
      isInVendorLinksContainer,
    } = this.props;
    const xoVendorRel = isExternalLink(xoVendorLink) ? 'nofollow' : undefined;

    return (
      <a
        className={`content link link-to-vendor ${
          isInVendorLinksContainer ? 'link-sm' : ''
        }`}
        href={xoVendorLink}
        rel={xoVendorRel}
        data-params={JSON.stringify(xoVendorLinkData)}
        onClick={this.vendorTrackEvents}
      >
        {vendorName}
      </a>
    );
  };

  vendorName = () => {
    const {vendorName} = this.props;
    return <span className="content value">{vendorName}</span>;
  };

  render() {
    const {iconName, iconTrackingData, iconClassName, xoVendorLink} =
      this.props;

    return (
      <div>
        <IconAgent
          iconName={iconName}
          className={iconClassName}
          trackingData={iconTrackingData}
        />
        {xoVendorLink ? this.vendorLink() : this.vendorName()}
      </div>
    );
  }
}
